export const MERGE_COUNT_FIELDS = [
  ['runs', 'visualGame.account.mergeRuns'],
  ['turns', 'visualGame.account.mergeTurns'],
  ['progress', 'visualGame.account.mergeProgress'],
  ['saveSlots', 'visualGame.account.mergeSaveSlots'],
  ['endingRecords', 'visualGame.account.mergeEndingRecords'],
  ['events', 'visualGame.account.mergeEvents'],
  ['agentCalls', 'visualGame.account.mergeAgentCalls'],
  ['billingLedger', 'visualGame.account.mergeBillingLedger'],
  ['billingUnlocks', 'visualGame.account.mergeBillingUnlocks'],
  ['billingFreeQuota', 'visualGame.account.mergeBillingFreeQuota'],
  ['paymentOrders', 'visualGame.account.mergePaymentOrders'],
]

export function emptyMergeCounts() {
  return Object.fromEntries(MERGE_COUNT_FIELDS.map(([key]) => [key, 0]))
}

/** @param {unknown} value */
export function countOf(value) {
  if (Array.isArray(value)) return value.length
  const count = value && typeof value === 'object' && 'count' in value ? value.count : value
  const number = Number(count)
  return Number.isFinite(number) && number > 0 ? number : 0
}

/** @param {Record<string, unknown>|null|undefined} result */
export function mergeTotal(result) {
  return MERGE_COUNT_FIELDS.reduce((sum, [key]) => sum + Number(result?.[key] || 0), 0)
}

/**
 * @param {Record<string, unknown>|null|undefined} result
 * @param {(key: string, values?: Record<string, unknown>) => string} t
 */
export function mergeDetails(result, t) {
  const items = []
  for (const [key, label] of MERGE_COUNT_FIELDS) {
    const count = Number(result?.[key] || 0)
    if (count > 0) items.push(t(label, { count }))
  }
  return items.join(t('visualGame.account.mergeSeparator'))
}
